import { makeStyles } from "tss-react/mui";
import get from "lodash/get";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function LinearProgressBar_styles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else LinearProgressBar_styles_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const useStyles = makeStyles()((theme, { height, color, transparentBackground })=>{
    const barColor = color ? get(theme.tokens.colors, color) || color : theme.tokens.colors.original.brand.primary;
    return {
        root: _object_spread_props(_object_spread({
            backgroundColor: transparentBackground ? 'transparent' : `${theme.tokens.colors.stroke.primary}`,
            borderRadius: theme.tokens.radius.m
        }, height && 'number' == typeof height && {
            height: `${theme.px(height)}px`
        }), {
            '& .MuiLinearProgress-bar': {
                borderRadius: theme.tokens.radius.m,
                backgroundColor: `${barColor}`
            }
        })
    };
});
export { useStyles };
